module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      disabled: !_vm.$slots.default
    }
  }, [_c('button', {
    staticClass: "hint hint--left btn dropbtn",
    attrs: {
      "data-label": "Ações",
      "disabled": !_vm.$slots.default
    },
    on: {
      "click": function($event) {
        return _vm.openDropdown()
      }
    }
  }, [_c('i', {
    staticClass: "dropbtn fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content",
    attrs: {
      "id": _vm.identifier
    }
  }, [_c('ul', [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a21307d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/ButtonActions.vue
// module id = 3385
// module chunks = 0